// processDocument.js
function processDocument(selectedDocument) {
    // Belgenin işleme kodu
    // Örnek: Belgenin bazı özelliklerini değiştirme veya ek veriler eklemek
    const processedDocument = {
        ...selectedDocument,
        // İşleme kodu buraya eklenebilir
    };

    return processedDocument;
}

export default processDocument;



// WEBPACK FOOTER //
// ./src/page/odaList/processDocument.js